module.exports = __webpack_public_path__ + "static/media/muffito_logo.db6c1c0d.png";